import { commonDateFormats } from '@thesavingsgroup/constants/commonDateFormats';
import moment from 'moment';

export const isValidDate = (value?: number | string | null): boolean => {
  if (typeof value === 'number') {
    return !isNaN(value) && isFinite(value);
  } else if (typeof value !== 'string') {
    return false;
  }

  const parsedDate = moment.utc(value, undefined, true);

  if (parsedDate.isValid()) {
    return true;
  }

  // fallback to common date formats if above parsing failed
  return moment(value, commonDateFormats, true).isValid();
};
